import ManagerCollector from './ManagerCollector';

export default ManagerCollector;
